import {useUnit} from 'effector-react';
import {useEffect} from 'react';
import {$partnersStore, fetchPartnerDetailRequested, toggleMemberFollowRequested} from '../store';
import {PartnerDetailResponse} from '../model/types';

export const usePartnerDetailViewModel = (partnerId: string | undefined) => {
  const [partnersState, fetchPartnerDetail, toggleMemberFollow] = useUnit([
    $partnersStore,
    fetchPartnerDetailRequested,
    toggleMemberFollowRequested,
  ]);

  const fetchPartnerById = (id: string) => {
    fetchPartnerDetail(id);
  };

  useEffect(() => {
    if (partnerId) {
      fetchPartnerDetail(partnerId);
    }
  }, [partnerId, fetchPartnerDetail]);

  const getPartnerDetail = (): PartnerDetailResponse | null => {
    return partnersState.selectedPartner;
  };

  const handleToggleMemberFollow = (memberId: string, isFollowing: boolean) => {
    toggleMemberFollow({memberId, isFollowing});
  };

  return {
    partner: partnersState.selectedPartner,
    loading: partnersState.loading,
    error: partnersState.error,
    fetchPartnerById,
    getPartnerDetail,
    toggleMemberFollow: handleToggleMemberFollow,
  };
};